// 统一的工具函数文件，用于在多个组件中共享功能

(function () {
  const cartDrawerFormInstance = null;

  // 打开购物车弹窗
  async function openCartDrawer() {
    // const drawerForm = document.querySelector('#CartDrawerForm');
    // if (drawerForm && window.theme?.CartForm) {
    //   if (!cartDrawerFormInstance) {
    //     cartDrawerFormInstance = new window.theme.CartForm(drawerForm);
    //   }
    //   await cartDrawerFormInstance.buildCart();
    // }
    // document.dispatchEvent(new CustomEvent('cart:open'));
    // 模拟按钮点击
    var cartButtons = document.querySelectorAll('.js-custom-cart-open');
    if (cartButtons && cartButtons.length > 0) {
      cartButtons[0].click();
    }
  }

  const ANONYMOUS_ID_KEY = '_anonymous_id';

  function getAnonymousId() {
    const localAnonymousId = localStorage.getItem(ANONYMOUS_ID_KEY);
    if (localAnonymousId) return localAnonymousId;

    const cookieAnonymousId = document.cookie.match(
      /(?:^|;\s*)_shopify_y=([^;]+)/,
    )?.[1];
    const anonymousId =
      cookieAnonymousId ||
      `${Math.random().toString(36).slice(2)}-${Date.now()}`;
    localStorage.setItem(ANONYMOUS_ID_KEY, anonymousId);
    return anonymousId;
  }

  // 获取用户身份信息
  function getIdentity() {
    const customerId = window.theme?.customerId
      ? `${window.theme.customerId}`
      : undefined;
    const anonymousId = getAnonymousId();
    return {
      ...(customerId ? { customerId: String(customerId) } : {}),
      ...(anonymousId ? { anonymousId } : {}),
    };
  }

  /**
   * 测试环境覆盖远程下发
   */
  function overrideExperiment(experimentName) {
    const overrideData = JSON.parse(
      localStorage.getItem('_statsig_override') || '{}',
    );
    return new Promise((resolve) => {
      const exp = {
        get: (key, defaultValue) => {
          return overrideData[experimentName]?.[key] ?? defaultValue;
        },
      };
      resolve(exp);
    });
  }

  let membershipCartEntryPromise;

  // 只由实际可见的购物车调用；预加载不触发实验曝光，同页共用结果。
  function getMembershipCartEntryEnabled() {
    if (!membershipCartEntryPromise) {
      membershipCartEntryPromise = Promise.resolve().then(async () => {
        const name = 'membership_cart_entry';
        const isTest = window.location.hostname.includes('127.0.0.1') ||
          window.location.hostname.includes('shopifypreview.com') ||
          localStorage.getItem('_shop_mode') === 'test';
        const experiment = isTest && window.jjbUtils?.overrideExperiment
          ? await window.jjbUtils.overrideExperiment(name)
          : (await window.statsigReady, await window.statsigClient?.getExperiment(name));
        return experiment?.get('enable', false) === true;
      }).catch(() => false);
    }
    return membershipCartEntryPromise;
  }

  window.jjbUtils = {
    overrideExperiment,
    getMembershipCartEntryEnabled,
    openCartDrawer,
    getIdentity,
  };
})();
